import { useState, useCallback } from "react";
import { handleLogout } from "@/lib/auth-utils";

/**
 * Custom hook that provides logout functionality with loading state management.
 * Redirects to the server-side logout endpoint for proper WorkOS session termination.
 *
 * @returns An object with logout function and loading state
 */
export function useLogout() {
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logoutUser = useCallback(async () => {
    setIsLoggingOut(true);
    try {
      // The handleLogout function will clear local state and redirect to the server logout endpoint
      await handleLogout();
    } catch {
      // The handleLogout function already handles errors,
      // but we want to reset the loading state if something goes wrong
      setIsLoggingOut(false);
    }
  }, []);

  return {
    logout: logoutUser,
    isLoggingOut,
  };
}
